export default "__VITE_ASSET__CMA_FpS$__"